import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

export function useSeasonSummary(leagueId: string | undefined, season: string | undefined) {
  return useQuery({
    queryKey: ['ai-summary', leagueId, season],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('ai_summaries')
        .select('id, content, created_at')
        .eq('league_id', leagueId!)
        .eq('season', season!)
        .eq('summary_type', 'season')
        .order('created_at', { ascending: false })
        .limit(1)
        .single()

      if (error?.code === 'PGRST116') return null
      if (error) throw error
      return data
    },
    enabled: !!leagueId && !!season,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
